import { jsx as t } from "react/jsx-runtime";
import { an as o, ao as r, c as b, d as c } from "../../vendor-EQDp64ng.js";
import { forwardRef as n } from "react";
import "../../theme/spacing.js";
import { omitStyleRenderProps as f } from "../../utils/omitStyleRenderProps/index.js";
import '../../assets/index28.css';const m = "_label_1yv03_1", s = {
  label: m
}, h = n((e, a) => {
  const [{ htmlFor: l }] = o(e, a, r);
  return e.children ? /* @__PURE__ */ t(
    b,
    {
      ...f(e),
      elementType: l ? "label" : "span",
      className: c(s.label, e.className),
      "data-component": "FieldLabel",
      slot: "label",
      children: e.children
    }
  ) : null;
});
export {
  h as FieldLabel
};
